import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { RunDto, RunDetailDto } from '@shared/types';

const LIST_KEY = ['admin', 'runs'] as const;

export function useAdminRuns() {
  const qc = useQueryClient();

  const list = useQuery({
    queryKey: LIST_KEY,
    queryFn: async () => (await api.get<{ data: RunDto[] }>('/admin/runs')).data,
    refetchInterval: 30_000, // poll while user is on page (běh trvá pár minut)
  });

  const trigger = useMutation({
    mutationFn: (reason?: string) =>
      api.post<{ data: { ok: boolean; githubActionsUrl: string; message: string } }>(
        '/admin/runs/trigger',
        { reason },
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: LIST_KEY }),
  });

  return { list, trigger };
}

export function useAdminRunDetail(id: string | null) {
  return useQuery({
    queryKey: ['admin', 'runs', id],
    enabled: id !== null,
    queryFn: async () => (await api.get<{ data: RunDetailDto }>(`/admin/runs/${id}`)).data,
  });
}
